import AXIOS from '@/axios-instance';

export default {

  saveElementNumber(uuid, elementId, num) {
    return AXIOS.post("/elementNumber", {
      number: num,
      uuidModel: uuid,
      elementId: elementId,
    });
  },
  retrieveDescription(uuidModel, elementId) {
    return AXIOS.get("/elementNumber/bpmn/" + uuidModel + "/element/" + elementId);
  },
  editElementNumber(uuid, elementId, num) {
    return AXIOS.put("/elementNumber", {
      number: num,
      uuidModel: uuid,
      elementId: elementId,
    });
  },
  retrieveElementsWithNumber(uuid) {
    return AXIOS.get("/elementNumber/bpmn/" + uuid);
  },
  removeElementNumber(uuidModel, elementId) {
    return AXIOS.delete("/elementNumber/bpmn/" + uuidModel + "/element/" + elementId)
  }
}